export default __webpack_public_path__ + "static/media/arrow-right-line-icon.662ec3db.svg";